export default [
    {
        'time': 1739001600000,
        'open': 8.859,
        'high': 8.879,
        'low': 8.74,
        'close': 8.742,
        'volume': 95619.45,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739005200000,
        'open': 8.744,
        'high': 8.829,
        'low': 8.743,
        'close': 8.815,
        'volume': 68390.25,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739008800000,
        'open': 8.814,
        'high': 8.839,
        'low': 8.748,
        'close': 8.77,
        'volume': 123548.54,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739012400000,
        'open': 8.769,
        'high': 8.817,
        'low': 8.726,
        'close': 8.802,
        'volume': 73773.72,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739016000000,
        'open': 8.804,
        'high': 8.844,
        'low': 8.752,
        'close': 8.79,
        'volume': 59728.73,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739019600000,
        'open': 8.793,
        'high': 8.961,
        'low': 8.79,
        'close': 8.901,
        'volume': 133137.29,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739023200000,
        'open': 8.9,
        'high': 8.923,
        'low': 8.824,
        'close': 8.913,
        'volume': 101667.78,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739026800000,
        'open': 8.915,
        'high': 8.961,
        'low': 8.829,
        'close': 8.891,
        'volume': 96323.27,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739030400000,
        'open': 8.892,
        'high': 9.004,
        'low': 8.867,
        'close': 8.983,
        'volume': 130944.04,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739034000000,
        'open': 8.985,
        'high': 9.129,
        'low': 8.985,
        'close': 9.1,
        'volume': 134312.16,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739037600000,
        'open': 9.101,
        'high': 9.165,
        'low': 9.019,
        'close': 9.138,
        'volume': 195972.09,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739041200000,
        'open': 9.138,
        'high': 9.16,
        'low': 9.039,
        'close': 9.062,
        'volume': 96827.95,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739044800000,
        'open': 9.063,
        'high': 9.094,
        'low': 9.011,
        'close': 9.093,
        'volume': 51850.66,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739048400000,
        'open': 9.092,
        'high': 9.138,
        'low': 9.068,
        'close': 9.116,
        'volume': 48290.32,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739052000000,
        'open': 9.118,
        'high': 9.161,
        'low': 9.1,
        'close': 9.122,
        'volume': 68632.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739055600000,
        'open': 9.122,
        'high': 9.174,
        'low': 9.122,
        'close': 9.139,
        'volume': 32018.11,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739059200000,
        'open': 9.138,
        'high': 9.143,
        'low': 9.061,
        'close': 9.118,
        'volume': 162419.28,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739062800000,
        'open': 9.118,
        'high': 9.168,
        'low': 9.058,
        'close': 9.07,
        'volume': 309254,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739066400000,
        'open': 9.07,
        'high': 9.102,
        'low': 8.979,
        'close': 9.025,
        'volume': 291588.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739070000000,
        'open': 9.025,
        'high': 9.285,
        'low': 9.008,
        'close': 9.258,
        'volume': 177614.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739073600000,
        'open': 9.255,
        'high': 9.255,
        'low': 9.153,
        'close': 9.199,
        'volume': 114286.1,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739077200000,
        'open': 9.2,
        'high': 9.215,
        'low': 9.17,
        'close': 9.195,
        'volume': 62819.53,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739080800000,
        'open': 9.198,
        'high': 9.253,
        'low': 9.163,
        'close': 9.231,
        'volume': 58681.38,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739084400000,
        'open': 9.23,
        'high': 9.268,
        'low': 9.181,
        'close': 9.261,
        'volume': 118078.08,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739088000000,
        'open': 9.261,
        'high': 9.298,
        'low': 9.216,
        'close': 9.279,
        'volume': 153541.51,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739091600000,
        'open': 9.28,
        'high': 9.29,
        'low': 9.226,
        'close': 9.237,
        'volume': 93573.28,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739095200000,
        'open': 9.236,
        'high': 9.29,
        'low': 9.211,
        'close': 9.238,
        'volume': 89261.66,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739098800000,
        'open': 9.237,
        'high': 9.262,
        'low': 9.192,
        'close': 9.196,
        'volume': 74048.79,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739102400000,
        'open': 9.197,
        'high': 9.228,
        'low': 9.135,
        'close': 9.181,
        'volume': 128956.94,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739106000000,
        'open': 9.184,
        'high': 9.197,
        'low': 8.984,
        'close': 9.01,
        'volume': 183004.82,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739109600000,
        'open': 9.01,
        'high': 9.106,
        'low': 8.994,
        'close': 9.096,
        'volume': 71003.68,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739113200000,
        'open': 9.097,
        'high': 9.277,
        'low': 9.093,
        'close': 9.258,
        'volume': 109930.52,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739116800000,
        'open': 9.258,
        'high': 9.32,
        'low': 9.233,
        'close': 9.292,
        'volume': 51007.05,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739120400000,
        'open': 9.293,
        'high': 9.31,
        'low': 9.194,
        'close': 9.24,
        'volume': 49354.58,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739124000000,
        'open': 9.238,
        'high': 9.244,
        'low': 9.181,
        'close': 9.194,
        'volume': 34083.6,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739127600000,
        'open': 9.194,
        'high': 9.223,
        'low': 9.023,
        'close': 9.054,
        'volume': 97826.75,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739131200000,
        'open': 9.053,
        'high': 9.148,
        'low': 9.043,
        'close': 9.095,
        'volume': 66466.12,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739134800000,
        'open': 9.094,
        'high': 9.108,
        'low': 8.732,
        'close': 8.783,
        'volume': 220275.61,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739138400000,
        'open': 8.782,
        'high': 9.159,
        'low': 8.696,
        'close': 9.045,
        'volume': 163668.77,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739142000000,
        'open': 9.041,
        'high': 9.15,
        'low': 8.993,
        'close': 9.13,
        'volume': 83518.44,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739145600000,
        'open': 9.131,
        'high': 9.296,
        'low': 9.128,
        'close': 9.17,
        'volume': 175141.38,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739149200000,
        'open': 9.168,
        'high': 9.182,
        'low': 8.849,
        'close': 8.868,
        'volume': 158133.82,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739152800000,
        'open': 8.868,
        'high': 9.018,
        'low': 8.821,
        'close': 8.982,
        'volume': 247300.86,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739156400000,
        'open': 8.981,
        'high': 9.255,
        'low': 8.938,
        'close': 9.129,
        'volume': 200355.98,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739160000000,
        'open': 9.128,
        'high': 9.206,
        'low': 9.069,
        'close': 9.12,
        'volume': 118167.05,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739163600000,
        'open': 9.122,
        'high': 9.227,
        'low': 9.077,
        'close': 9.137,
        'volume': 93695.55,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739167200000,
        'open': 9.138,
        'high': 9.158,
        'low': 9.072,
        'close': 9.132,
        'volume': 56029.57,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739170800000,
        'open': 9.132,
        'high': 9.171,
        'low': 9.099,
        'close': 9.141,
        'volume': 43209.38,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739174400000,
        'open': 9.138,
        'high': 9.3,
        'low': 9.128,
        'close': 9.2,
        'volume': 332342.37,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739178000000,
        'open': 9.2,
        'high': 9.282,
        'low': 9.185,
        'close': 9.211,
        'volume': 226002.9,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739181600000,
        'open': 9.211,
        'high': 9.24,
        'low': 9.103,
        'close': 9.167,
        'volume': 259487.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739185200000,
        'open': 9.167,
        'high': 9.202,
        'low': 9.124,
        'close': 9.183,
        'volume': 68418.21,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739188800000,
        'open': 9.181,
        'high': 9.206,
        'low': 9.07,
        'close': 9.116,
        'volume': 83479.36,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739192400000,
        'open': 9.116,
        'high': 9.372,
        'low': 9.103,
        'close': 9.342,
        'volume': 102030.48,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739196000000,
        'open': 9.344,
        'high': 9.362,
        'low': 9.178,
        'close': 9.233,
        'volume': 145965.97,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739199600000,
        'open': 9.235,
        'high': 9.266,
        'low': 9.162,
        'close': 9.216,
        'volume': 133095.41,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739203200000,
        'open': 9.217,
        'high': 9.497,
        'low': 9.198,
        'close': 9.43,
        'volume': 521648.1,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739206800000,
        'open': 9.43,
        'high': 9.49,
        'low': 9.288,
        'close': 9.445,
        'volume': 212519.94,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739210400000,
        'open': 9.444,
        'high': 9.541,
        'low': 9.395,
        'close': 9.464,
        'volume': 116675.32,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739214000000,
        'open': 9.463,
        'high': 9.49,
        'low': 9.422,
        'close': 9.469,
        'volume': 63864.62,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739217600000,
        'open': 9.468,
        'high': 9.601,
        'low': 9.465,
        'close': 9.573,
        'volume': 156342.41,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739221200000,
        'open': 9.572,
        'high': 9.583,
        'low': 9.518,
        'close': 9.542,
        'volume': 78462.09,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739224800000,
        'open': 9.542,
        'high': 9.603,
        'low': 9.463,
        'close': 9.505,
        'volume': 129134.05,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739228400000,
        'open': 9.505,
        'high': 9.509,
        'low': 9.396,
        'close': 9.458,
        'volume': 80328.08,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739232000000,
        'open': 9.458,
        'high': 9.706,
        'low': 9.454,
        'close': 9.703,
        'volume': 219716.68,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739235600000,
        'open': 9.703,
        'high': 9.783,
        'low': 9.645,
        'close': 9.682,
        'volume': 127346.04,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739239200000,
        'open': 9.681,
        'high': 9.738,
        'low': 9.603,
        'close': 9.635,
        'volume': 138042.32,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739242800000,
        'open': 9.638,
        'high': 9.687,
        'low': 9.579,
        'close': 9.668,
        'volume': 76247.66,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739246400000,
        'open': 9.668,
        'high': 9.853,
        'low': 9.668,
        'close': 9.848,
        'volume': 162624.59,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739250000000,
        'open': 9.849,
        'high': 10.018,
        'low': 9.82,
        'close': 10.001,
        'volume': 285256.07,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739253600000,
        'open': 10.002,
        'high': 10.045,
        'low': 9.908,
        'close': 10.026,
        'volume': 95333.87,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739257200000,
        'open': 10.025,
        'high': 10.027,
        'low': 9.926,
        'close': 9.984,
        'volume': 131746.8,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739260800000,
        'open': 9.983,
        'high': 10.036,
        'low': 9.96,
        'close': 10.001,
        'volume': 241469.66,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739264400000,
        'open': 10,
        'high': 10.02,
        'low': 9.912,
        'close': 9.939,
        'volume': 185286.75,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739268000000,
        'open': 9.937,
        'high': 9.963,
        'low': 9.872,
        'close': 9.886,
        'volume': 91239.96,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739271600000,
        'open': 9.886,
        'high': 9.966,
        'low': 9.884,
        'close': 9.961,
        'volume': 107148.43,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739275200000,
        'open': 9.96,
        'high': 9.966,
        'low': 9.794,
        'close': 9.833,
        'volume': 105050.15,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739278800000,
        'open': 9.832,
        'high': 9.854,
        'low': 9.544,
        'close': 9.566,
        'volume': 214565.18,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739282400000,
        'open': 9.564,
        'high': 9.789,
        'low': 9.553,
        'close': 9.781,
        'volume': 269216.97,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739286000000,
        'open': 9.782,
        'high': 9.842,
        'low': 9.6,
        'close': 9.642,
        'volume': 238536.93,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739289600000,
        'open': 9.643,
        'high': 9.706,
        'low': 9.588,
        'close': 9.623,
        'volume': 309484.73,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739293200000,
        'open': 9.624,
        'high': 9.642,
        'low': 9.445,
        'close': 9.524,
        'volume': 622166.91,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739296800000,
        'open': 9.525,
        'high': 9.544,
        'low': 9.325,
        'close': 9.362,
        'volume': 195311.55,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739300400000,
        'open': 9.364,
        'high': 9.395,
        'low': 9.244,
        'close': 9.294,
        'volume': 97682.59,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739304000000,
        'open': 9.291,
        'high': 9.412,
        'low': 9.274,
        'close': 9.363,
        'volume': 61943.48,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739307600000,
        'open': 9.362,
        'high': 9.46,
        'low': 9.31,
        'close': 9.383,
        'volume': 105100.79,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739311200000,
        'open': 9.383,
        'high': 9.493,
        'low': 9.324,
        'close': 9.347,
        'volume': 93538.03,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739314800000,
        'open': 9.347,
        'high': 9.434,
        'low': 9.341,
        'close': 9.381,
        'volume': 338729.68,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739318400000,
        'open': 9.38,
        'high': 9.452,
        'low': 9.32,
        'close': 9.424,
        'volume': 161351.21,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739322000000,
        'open': 9.423,
        'high': 9.449,
        'low': 9.339,
        'close': 9.424,
        'volume': 82058.99,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739325600000,
        'open': 9.425,
        'high': 9.434,
        'low': 9.284,
        'close': 9.321,
        'volume': 89301.48,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739329200000,
        'open': 9.321,
        'high': 9.387,
        'low': 9.237,
        'close': 9.305,
        'volume': 83202.1,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739332800000,
        'open': 9.303,
        'high': 9.332,
        'low': 9.238,
        'close': 9.289,
        'volume': 387197.34,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739336400000,
        'open': 9.291,
        'high': 9.42,
        'low': 9.241,
        'close': 9.412,
        'volume': 135461.87,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739340000000,
        'open': 9.412,
        'high': 9.425,
        'low': 9.328,
        'close': 9.346,
        'volume': 78409.51,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739343600000,
        'open': 9.343,
        'high': 9.519,
        'low': 9.328,
        'close': 9.488,
        'volume': 61573.52,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739347200000,
        'open': 9.487,
        'high': 9.574,
        'low': 9.475,
        'close': 9.488,
        'volume': 81796.96,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739350800000,
        'open': 9.486,
        'high': 9.493,
        'low': 9.387,
        'close': 9.441,
        'volume': 84262.63,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739354400000,
        'open': 9.441,
        'high': 9.453,
        'low': 9.367,
        'close': 9.416,
        'volume': 136556.81,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739358000000,
        'open': 9.418,
        'high': 9.524,
        'low': 9.417,
        'close': 9.475,
        'volume': 153748.3,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739361600000,
        'open': 9.481,
        'high': 9.573,
        'low': 9.467,
        'close': 9.487,
        'volume': 53588.57,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739365200000,
        'open': 9.485,
        'high': 9.6,
        'low': 9.078,
        'close': 9.27,
        'volume': 806810.98,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739368800000,
        'open': 9.27,
        'high': 9.343,
        'low': 9.085,
        'close': 9.337,
        'volume': 268045.17,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739372400000,
        'open': 9.336,
        'high': 9.501,
        'low': 9.202,
        'close': 9.453,
        'volume': 254220.35,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739376000000,
        'open': 9.454,
        'high': 9.68,
        'low': 9.343,
        'close': 9.649,
        'volume': 205036.31,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739379600000,
        'open': 9.648,
        'high': 9.732,
        'low': 9.616,
        'close': 9.654,
        'volume': 206060.69,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739383200000,
        'open': 9.655,
        'high': 9.668,
        'low': 9.575,
        'close': 9.648,
        'volume': 100920.91,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739386800000,
        'open': 9.649,
        'high': 9.799,
        'low': 9.596,
        'close': 9.786,
        'volume': 87914.06,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739390400000,
        'open': 9.787,
        'high': 9.856,
        'low': 9.752,
        'close': 9.803,
        'volume': 100849.22,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739394000000,
        'open': 9.804,
        'high': 9.89,
        'low': 9.725,
        'close': 9.815,
        'volume': 81467.77,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739397600000,
        'open': 9.816,
        'high': 10.134,
        'low': 9.767,
        'close': 10.007,
        'volume': 283084.99,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739401200000,
        'open': 10.004,
        'high': 10.071,
        'low': 9.922,
        'close': 9.951,
        'volume': 137666.81,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739404800000,
        'open': 9.955,
        'high': 9.983,
        'low': 9.868,
        'close': 9.909,
        'volume': 79587.17,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739408400000,
        'open': 9.908,
        'high': 10.082,
        'low': 9.892,
        'close': 10.041,
        'volume': 121452.5,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739412000000,
        'open': 10.04,
        'high': 10.04,
        'low': 9.898,
        'close': 9.94,
        'volume': 109815.82,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739415600000,
        'open': 9.942,
        'high': 9.984,
        'low': 9.917,
        'close': 9.965,
        'volume': 49583.92,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739419200000,
        'open': 9.966,
        'high': 9.976,
        'low': 9.785,
        'close': 9.819,
        'volume': 92364.6,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739422800000,
        'open': 9.82,
        'high': 9.926,
        'low': 9.766,
        'close': 9.854,
        'volume': 148826.63,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739426400000,
        'open': 9.855,
        'high': 9.901,
        'low': 9.691,
        'close': 9.733,
        'volume': 189922.68,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739430000000,
        'open': 9.732,
        'high': 9.769,
        'low': 9.657,
        'close': 9.682,
        'volume': 75391.7,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739433600000,
        'open': 9.683,
        'high': 9.731,
        'low': 9.608,
        'close': 9.646,
        'volume': 65581.64,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739437200000,
        'open': 9.646,
        'high': 9.754,
        'low': 9.611,
        'close': 9.728,
        'volume': 64824.23,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739440800000,
        'open': 9.726,
        'high': 9.789,
        'low': 9.707,
        'close': 9.717,
        'volume': 54410.41,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739444400000,
        'open': 9.719,
        'high': 9.726,
        'low': 9.594,
        'close': 9.634,
        'volume': 68623.92,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739448000000,
        'open': 9.635,
        'high': 9.653,
        'low': 9.574,
        'close': 9.596,
        'volume': 48179.44,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739451600000,
        'open': 9.599,
        'high': 9.715,
        'low': 9.575,
        'close': 9.644,
        'volume': 147178.45,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739455200000,
        'open': 9.642,
        'high': 9.642,
        'low': 9.471,
        'close': 9.517,
        'volume': 203459.15,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739458800000,
        'open': 9.516,
        'high': 9.69,
        'low': 9.464,
        'close': 9.58,
        'volume': 155684.64,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739462400000,
        'open': 9.579,
        'high': 9.618,
        'low': 9.51,
        'close': 9.531,
        'volume': 127298.61,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739466000000,
        'open': 9.53,
        'high': 9.648,
        'low': 9.525,
        'close': 9.57,
        'volume': 60546.64,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739469600000,
        'open': 9.57,
        'high': 9.651,
        'low': 9.514,
        'close': 9.651,
        'volume': 94483.42,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739473200000,
        'open': 9.651,
        'high': 9.724,
        'low': 9.574,
        'close': 9.596,
        'volume': 60843.77,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739476800000,
        'open': 9.599,
        'high': 9.677,
        'low': 9.597,
        'close': 9.676,
        'volume': 65863.97,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739480400000,
        'open': 9.675,
        'high': 9.854,
        'low': 9.66,
        'close': 9.768,
        'volume': 95949.59,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739484000000,
        'open': 9.769,
        'high': 9.852,
        'low': 9.754,
        'close': 9.811,
        'volume': 42395.75,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739487600000,
        'open': 9.813,
        'high': 9.891,
        'low': 9.801,
        'close': 9.889,
        'volume': 71155.38,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739491200000,
        'open': 9.891,
        'high': 9.914,
        'low': 9.821,
        'close': 9.882,
        'volume': 96679.6,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739494800000,
        'open': 9.881,
        'high': 9.908,
        'low': 9.804,
        'close': 9.879,
        'volume': 60575.82,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739498400000,
        'open': 9.879,
        'high': 9.977,
        'low': 9.861,
        'close': 9.96,
        'volume': 106444.69,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739502000000,
        'open': 9.96,
        'high': 10.063,
        'low': 9.931,
        'close': 10.044,
        'volume': 305281.19,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739505600000,
        'open': 10.046,
        'high': 10.047,
        'low': 9.914,
        'close': 9.932,
        'volume': 65430.44,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739509200000,
        'open': 9.933,
        'high': 9.95,
        'low': 9.847,
        'close': 9.88,
        'volume': 54307.42,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739512800000,
        'open': 9.878,
        'high': 9.898,
        'low': 9.848,
        'close': 9.885,
        'volume': 78107.56,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739516400000,
        'open': 9.886,
        'high': 9.912,
        'low': 9.851,
        'close': 9.881,
        'volume': 138976.01,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739520000000,
        'open': 9.881,
        'high': 10.01,
        'low': 9.881,
        'close': 9.983,
        'volume': 77050.62,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739523600000,
        'open': 9.983,
        'high': 10.086,
        'low': 9.977,
        'close': 10.072,
        'volume': 131764.13,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739527200000,
        'open': 10.071,
        'high': 10.095,
        'low': 9.926,
        'close': 9.958,
        'volume': 83951.91,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739530800000,
        'open': 9.958,
        'high': 9.997,
        'low': 9.926,
        'close': 9.958,
        'volume': 128942.57,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739534400000,
        'open': 9.957,
        'high': 9.967,
        'low': 9.911,
        'close': 9.963,
        'volume': 71616.47,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739538000000,
        'open': 9.963,
        'high': 10.077,
        'low': 9.952,
        'close': 10.063,
        'volume': 104736.63,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739541600000,
        'open': 10.065,
        'high': 10.134,
        'low': 9.984,
        'close': 10.107,
        'volume': 129522.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739545200000,
        'open': 10.107,
        'high': 10.133,
        'low': 9.947,
        'close': 10.108,
        'volume': 102106.95,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739548800000,
        'open': 10.109,
        'high': 10.178,
        'low': 10.008,
        'close': 10.17,
        'volume': 104255.81,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739552400000,
        'open': 10.169,
        'high': 10.339,
        'low': 10.096,
        'close': 10.269,
        'volume': 199278.71,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739556000000,
        'open': 10.27,
        'high': 10.355,
        'low': 10.141,
        'close': 10.157,
        'volume': 254511.49,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739559600000,
        'open': 10.161,
        'high': 10.209,
        'low': 10.069,
        'close': 10.106,
        'volume': 65723.14,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739563200000,
        'open': 10.107,
        'high': 10.119,
        'low': 9.993,
        'close': 10.022,
        'volume': 54189.49,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739566800000,
        'open': 10.023,
        'high': 10.134,
        'low': 9.957,
        'close': 10.129,
        'volume': 46169.26,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739570400000,
        'open': 10.129,
        'high': 10.185,
        'low': 9.961,
        'close': 10.019,
        'volume': 67031.38,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739574000000,
        'open': 10.021,
        'high': 10.07,
        'low': 9.984,
        'close': 10.056,
        'volume': 32755.06,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739577600000,
        'open': 10.057,
        'high': 10.067,
        'low': 9.935,
        'close': 9.997,
        'volume': 37051.07,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739581200000,
        'open': 9.999,
        'high': 10.096,
        'low': 9.993,
        'close': 10.085,
        'volume': 28252.93,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739584800000,
        'open': 10.084,
        'high': 10.122,
        'low': 10.047,
        'close': 10.122,
        'volume': 31581.87,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739588400000,
        'open': 10.12,
        'high': 10.147,
        'low': 10.09,
        'close': 10.099,
        'volume': 189729.3,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739592000000,
        'open': 10.1,
        'high': 10.132,
        'low': 10.058,
        'close': 10.08,
        'volume': 117515.58,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739595600000,
        'open': 10.079,
        'high': 10.148,
        'low': 10.075,
        'close': 10.106,
        'volume': 39462.81,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739599200000,
        'open': 10.107,
        'high': 10.111,
        'low': 9.968,
        'close': 9.986,
        'volume': 32592.73,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739602800000,
        'open': 9.985,
        'high': 9.997,
        'low': 9.903,
        'close': 9.903,
        'volume': 135796.47,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739606400000,
        'open': 9.905,
        'high': 9.975,
        'low': 9.904,
        'close': 9.924,
        'volume': 58617.72,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739610000000,
        'open': 9.927,
        'high': 9.952,
        'low': 9.865,
        'close': 9.894,
        'volume': 50427.74,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739613600000,
        'open': 9.895,
        'high': 9.965,
        'low': 9.85,
        'close': 9.941,
        'volume': 128983.45,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739617200000,
        'open': 9.943,
        'high': 9.977,
        'low': 9.847,
        'close': 9.869,
        'volume': 113704.55,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739620800000,
        'open': 9.87,
        'high': 9.956,
        'low': 9.857,
        'close': 9.936,
        'volume': 126332.92,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739624400000,
        'open': 9.937,
        'high': 9.963,
        'low': 9.893,
        'close': 9.893,
        'volume': 19998.14,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739628000000,
        'open': 9.893,
        'high': 9.907,
        'low': 9.742,
        'close': 9.827,
        'volume': 136277.03,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739631600000,
        'open': 9.828,
        'high': 9.88,
        'low': 9.822,
        'close': 9.85,
        'volume': 90699.72,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739635200000,
        'open': 9.852,
        'high': 9.882,
        'low': 9.793,
        'close': 9.81,
        'volume': 46115.79,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739638800000,
        'open': 9.809,
        'high': 9.835,
        'low': 9.765,
        'close': 9.785,
        'volume': 32816.72,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739642400000,
        'open': 9.785,
        'high': 9.869,
        'low': 9.78,
        'close': 9.85,
        'volume': 19439.66,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739646000000,
        'open': 9.85,
        'high': 9.86,
        'low': 9.776,
        'close': 9.782,
        'volume': 70258.47,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739649600000,
        'open': 9.782,
        'high': 9.808,
        'low': 9.716,
        'close': 9.765,
        'volume': 28583.24,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739653200000,
        'open': 9.765,
        'high': 9.816,
        'low': 9.763,
        'close': 9.803,
        'volume': 28192.91,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739656800000,
        'open': 9.804,
        'high': 9.816,
        'low': 9.744,
        'close': 9.778,
        'volume': 22538.82,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739660400000,
        'open': 9.78,
        'high': 9.83,
        'low': 9.764,
        'close': 9.811,
        'volume': 15105.56,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739664000000,
        'open': 9.811,
        'high': 9.87,
        'low': 9.79,
        'close': 9.825,
        'volume': 29604.54,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739667600000,
        'open': 9.826,
        'high': 9.856,
        'low': 9.786,
        'close': 9.847,
        'volume': 26251.57,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739671200000,
        'open': 9.847,
        'high': 9.861,
        'low': 9.766,
        'close': 9.784,
        'volume': 65511.02,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739674800000,
        'open': 9.784,
        'high': 9.815,
        'low': 9.744,
        'close': 9.789,
        'volume': 255128.05,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739678400000,
        'open': 9.788,
        'high': 9.841,
        'low': 9.771,
        'close': 9.795,
        'volume': 93965,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739682000000,
        'open': 9.796,
        'high': 9.851,
        'low': 9.76,
        'close': 9.813,
        'volume': 46988,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739685600000,
        'open': 9.814,
        'high': 9.892,
        'low': 9.802,
        'close': 9.838,
        'volume': 60742.98,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739689200000,
        'open': 9.838,
        'high': 9.838,
        'low': 9.718,
        'close': 9.743,
        'volume': 48025.92,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739692800000,
        'open': 9.745,
        'high': 9.826,
        'low': 9.71,
        'close': 9.804,
        'volume': 29838.92,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739696400000,
        'open': 9.805,
        'high': 9.913,
        'low': 9.774,
        'close': 9.904,
        'volume': 69773.19,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739700000000,
        'open': 9.905,
        'high': 9.932,
        'low': 9.84,
        'close': 9.849,
        'volume': 50594.01,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739703600000,
        'open': 9.846,
        'high': 9.943,
        'low': 9.841,
        'close': 9.941,
        'volume': 19736.9,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739707200000,
        'open': 9.939,
        'high': 9.94,
        'low': 9.862,
        'close': 9.874,
        'volume': 58532.43,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739710800000,
        'open': 9.872,
        'high': 9.873,
        'low': 9.74,
        'close': 9.754,
        'volume': 58082.63,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739714400000,
        'open': 9.754,
        'high': 9.807,
        'low': 9.671,
        'close': 9.725,
        'volume': 237781.14,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739718000000,
        'open': 9.727,
        'high': 9.773,
        'low': 9.712,
        'close': 9.715,
        'volume': 69705.16,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739721600000,
        'open': 9.715,
        'high': 9.774,
        'low': 9.67,
        'close': 9.704,
        'volume': 84438.93,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739725200000,
        'open': 9.704,
        'high': 9.749,
        'low': 9.653,
        'close': 9.665,
        'volume': 28352.32,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739728800000,
        'open': 9.664,
        'high': 9.665,
        'low': 9.566,
        'close': 9.637,
        'volume': 67369.77,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739732400000,
        'open': 9.635,
        'high': 9.701,
        'low': 9.597,
        'close': 9.675,
        'volume': 19319.65,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739736000000,
        'open': 9.674,
        'high': 9.713,
        'low': 9.623,
        'close': 9.634,
        'volume': 16105.62,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739739600000,
        'open': 9.633,
        'high': 9.698,
        'low': 9.586,
        'close': 9.667,
        'volume': 27736.48,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739743200000,
        'open': 9.671,
        'high': 9.741,
        'low': 9.601,
        'close': 9.655,
        'volume': 46957.86,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739746800000,
        'open': 9.662,
        'high': 9.662,
        'low': 9.569,
        'close': 9.585,
        'volume': 47898.85,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739750400000,
        'open': 9.584,
        'high': 9.648,
        'low': 9.57,
        'close': 9.645,
        'volume': 25759.12,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739754000000,
        'open': 9.644,
        'high': 9.731,
        'low': 9.622,
        'close': 9.715,
        'volume': 27011.43,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739757600000,
        'open': 9.714,
        'high': 9.755,
        'low': 9.665,
        'close': 9.676,
        'volume': 34582.75,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739761200000,
        'open': 9.675,
        'high': 9.688,
        'low': 9.604,
        'close': 9.681,
        'volume': 47390.59,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739764800000,
        'open': 9.681,
        'high': 9.681,
        'low': 9.566,
        'close': 9.568,
        'volume': 46951.88,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739768400000,
        'open': 9.567,
        'high': 9.648,
        'low': 9.444,
        'close': 9.636,
        'volume': 159042.32,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739772000000,
        'open': 9.637,
        'high': 9.817,
        'low': 9.625,
        'close': 9.759,
        'volume': 136276.15,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739775600000,
        'open': 9.76,
        'high': 9.817,
        'low': 9.649,
        'close': 9.683,
        'volume': 82958.41,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739779200000,
        'open': 9.684,
        'high': 9.849,
        'low': 9.643,
        'close': 9.819,
        'volume': 98963.3,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739782800000,
        'open': 9.82,
        'high': 9.896,
        'low': 9.738,
        'close': 9.849,
        'volume': 164535.76,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739786400000,
        'open': 9.85,
        'high': 10.039,
        'low': 9.849,
        'close': 9.94,
        'volume': 211890.53,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739790000000,
        'open': 9.937,
        'high': 10.024,
        'low': 9.896,
        'close': 10.021,
        'volume': 131536.01,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739793600000,
        'open': 10.02,
        'high': 10.074,
        'low': 10.007,
        'close': 10.018,
        'volume': 92742.11,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739797200000,
        'open': 10.017,
        'high': 10.031,
        'low': 9.934,
        'close': 9.934,
        'volume': 98799.34,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739800800000,
        'open': 9.934,
        'high': 10.181,
        'low': 9.934,
        'close': 10.181,
        'volume': 181627.49,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739804400000,
        'open': 10.181,
        'high': 10.247,
        'low': 9.821,
        'close': 9.86,
        'volume': 354645.69,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739808000000,
        'open': 9.86,
        'high': 9.944,
        'low': 9.727,
        'close': 9.737,
        'volume': 161099.23,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739811600000,
        'open': 9.736,
        'high': 9.856,
        'low': 9.727,
        'close': 9.738,
        'volume': 82020.52,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739815200000,
        'open': 9.737,
        'high': 9.847,
        'low': 9.652,
        'close': 9.725,
        'volume': 148467.63,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739818800000,
        'open': 9.724,
        'high': 9.867,
        'low': 9.685,
        'close': 9.83,
        'volume': 80618.41,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739822400000,
        'open': 9.829,
        'high': 9.871,
        'low': 9.779,
        'close': 9.805,
        'volume': 51701,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739826000000,
        'open': 9.8,
        'high': 10.17,
        'low': 9.799,
        'close': 10.057,
        'volume': 134296.71,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739829600000,
        'open': 10.06,
        'high': 10.067,
        'low': 9.823,
        'close': 9.842,
        'volume': 96332.82,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739833200000,
        'open': 9.844,
        'high': 9.951,
        'low': 9.844,
        'close': 9.947,
        'volume': 34351.33,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739836800000,
        'open': 9.944,
        'high': 9.953,
        'low': 9.753,
        'close': 9.763,
        'volume': 59488.19,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739840400000,
        'open': 9.763,
        'high': 9.903,
        'low': 9.751,
        'close': 9.888,
        'volume': 52148.01,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739844000000,
        'open': 9.889,
        'high': 9.915,
        'low': 9.818,
        'close': 9.873,
        'volume': 123279.16,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739847600000,
        'open': 9.873,
        'high': 9.91,
        'low': 9.795,
        'close': 9.827,
        'volume': 46716.79,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739851200000,
        'open': 9.826,
        'high': 9.846,
        'low': 9.742,
        'close': 9.792,
        'volume': 54064.66,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739854800000,
        'open': 9.793,
        'high': 9.796,
        'low': 9.614,
        'close': 9.626,
        'volume': 77534.07,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739858400000,
        'open': 9.627,
        'high': 9.669,
        'low': 9.447,
        'close': 9.53,
        'volume': 319001.02,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739862000000,
        'open': 9.529,
        'high': 9.639,
        'low': 9.487,
        'close': 9.555,
        'volume': 117836.91,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739865600000,
        'open': 9.555,
        'high': 9.584,
        'low': 9.421,
        'close': 9.469,
        'volume': 106770.49,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739869200000,
        'open': 9.467,
        'high': 9.714,
        'low': 9.436,
        'close': 9.714,
        'volume': 128932.2,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739872800000,
        'open': 9.714,
        'high': 9.75,
        'low': 9.621,
        'close': 9.662,
        'volume': 64927.61,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739876400000,
        'open': 9.663,
        'high': 9.667,
        'low': 9.564,
        'close': 9.583,
        'volume': 45871.82,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739880000000,
        'open': 9.581,
        'high': 9.78,
        'low': 9.563,
        'close': 9.718,
        'volume': 73854.23,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739883600000,
        'open': 9.718,
        'high': 9.718,
        'low': 9.6,
        'close': 9.653,
        'volume': 65899.43,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739887200000,
        'open': 9.658,
        'high': 9.776,
        'low': 9.47,
        'close': 9.545,
        'volume': 153157.83,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739890800000,
        'open': 9.547,
        'high': 9.549,
        'low': 9.322,
        'close': 9.35,
        'volume': 340140.24,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739894400000,
        'open': 9.352,
        'high': 9.409,
        'low': 9.172,
        'close': 9.183,
        'volume': 232989.22,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739898000000,
        'open': 9.183,
        'high': 9.281,
        'low': 9.143,
        'close': 9.2,
        'volume': 116889.17,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739901600000,
        'open': 9.198,
        'high': 9.3,
        'low': 9.17,
        'close': 9.238,
        'volume': 100267.24,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739905200000,
        'open': 9.238,
        'high': 9.285,
        'low': 9.146,
        'close': 9.256,
        'volume': 88408.78,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739908800000,
        'open': 9.257,
        'high': 9.345,
        'low': 9.217,
        'close': 9.29,
        'volume': 94271.33,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739912400000,
        'open': 9.29,
        'high': 9.46,
        'low': 9.28,
        'close': 9.359,
        'volume': 66905.6,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739916000000,
        'open': 9.36,
        'high': 9.564,
        'low': 9.352,
        'close': 9.456,
        'volume': 340617.31,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739919600000,
        'open': 9.455,
        'high': 9.635,
        'low': 9.425,
        'close': 9.632,
        'volume': 116355,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739923200000,
        'open': 9.631,
        'high': 9.669,
        'low': 9.54,
        'close': 9.546,
        'volume': 46783.7,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739926800000,
        'open': 9.551,
        'high': 9.563,
        'low': 9.462,
        'close': 9.505,
        'volume': 77265.83,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739930400000,
        'open': 9.505,
        'high': 9.669,
        'low': 9.503,
        'close': 9.636,
        'volume': 108298.97,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739934000000,
        'open': 9.637,
        'high': 9.637,
        'low': 9.51,
        'close': 9.539,
        'volume': 50134.58,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739937600000,
        'open': 9.539,
        'high': 9.551,
        'low': 9.397,
        'close': 9.397,
        'volume': 54085.48,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739941200000,
        'open': 9.396,
        'high': 9.502,
        'low': 9.384,
        'close': 9.475,
        'volume': 36647.5,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739944800000,
        'open': 9.476,
        'high': 9.58,
        'low': 9.459,
        'close': 9.55,
        'volume': 55341.73,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739948400000,
        'open': 9.55,
        'high': 9.727,
        'low': 9.543,
        'close': 9.68,
        'volume': 158988.11,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739952000000,
        'open': 9.679,
        'high': 9.724,
        'low': 9.603,
        'close': 9.608,
        'volume': 55628.77,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739955600000,
        'open': 9.608,
        'high': 9.683,
        'low': 9.598,
        'close': 9.658,
        'volume': 168795.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739959200000,
        'open': 9.658,
        'high': 9.73,
        'low': 9.613,
        'close': 9.646,
        'volume': 89290.44,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739962800000,
        'open': 9.646,
        'high': 9.685,
        'low': 9.601,
        'close': 9.644,
        'volume': 39127.41,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739966400000,
        'open': 9.645,
        'high': 9.652,
        'low': 9.492,
        'close': 9.495,
        'volume': 86665.2,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739970000000,
        'open': 9.496,
        'high': 9.644,
        'low': 9.496,
        'close': 9.621,
        'volume': 214944.02,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739973600000,
        'open': 9.621,
        'high': 9.674,
        'low': 9.469,
        'close': 9.48,
        'volume': 217485.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739977200000,
        'open': 9.481,
        'high': 9.585,
        'low': 9.436,
        'close': 9.48,
        'volume': 211251.9,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739980800000,
        'open': 9.481,
        'high': 9.583,
        'low': 9.473,
        'close': 9.511,
        'volume': 96636.02,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739984400000,
        'open': 9.511,
        'high': 9.545,
        'low': 9.449,
        'close': 9.5,
        'volume': 67523.15,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739988000000,
        'open': 9.5,
        'high': 9.59,
        'low': 9.442,
        'close': 9.528,
        'volume': 141732,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739991600000,
        'open': 9.529,
        'high': 9.616,
        'low': 9.5,
        'close': 9.536,
        'volume': 95838.35,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739995200000,
        'open': 9.537,
        'high': 9.56,
        'low': 9.486,
        'close': 9.497,
        'volume': 137059.97,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1739998800000,
        'open': 9.499,
        'high': 9.521,
        'low': 9.395,
        'close': 9.416,
        'volume': 150808.98,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740002400000,
        'open': 9.415,
        'high': 9.492,
        'low': 9.378,
        'close': 9.449,
        'volume': 143650.7,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740006000000,
        'open': 9.451,
        'high': 9.537,
        'low': 9.43,
        'close': 9.434,
        'volume': 138301.18,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740009600000,
        'open': 9.434,
        'high': 9.495,
        'low': 9.379,
        'close': 9.465,
        'volume': 140869,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740013200000,
        'open': 9.464,
        'high': 9.499,
        'low': 9.328,
        'close': 9.35,
        'volume': 161079.66,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740016800000,
        'open': 9.35,
        'high': 9.528,
        'low': 9.338,
        'close': 9.496,
        'volume': 191667.24,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740020400000,
        'open': 9.498,
        'high': 9.567,
        'low': 9.416,
        'close': 9.42,
        'volume': 217976.81,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740024000000,
        'open': 9.421,
        'high': 9.52,
        'low': 9.395,
        'close': 9.402,
        'volume': 182340.39,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740027600000,
        'open': 9.401,
        'high': 9.411,
        'low': 9.32,
        'close': 9.322,
        'volume': 148468.53,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740031200000,
        'open': 9.322,
        'high': 9.335,
        'low': 9.249,
        'close': 9.266,
        'volume': 163529.71,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740034800000,
        'open': 9.266,
        'high': 9.297,
        'low': 9.236,
        'close': 9.242,
        'volume': 123842.21,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740038400000,
        'open': 9.242,
        'high': 9.275,
        'low': 9.216,
        'close': 9.244,
        'volume': 149205,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740042000000,
        'open': 9.245,
        'high': 9.255,
        'low': 9.187,
        'close': 9.191,
        'volume': 167968.06,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740045600000,
        'open': 9.191,
        'high': 9.274,
        'low': 9.177,
        'close': 9.261,
        'volume': 200198.86,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740049200000,
        'open': 9.261,
        'high': 9.311,
        'low': 9.196,
        'close': 9.201,
        'volume': 212093,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740052800000,
        'open': 9.202,
        'high': 9.261,
        'low': 9.185,
        'close': 9.234,
        'volume': 231517.65,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740056400000,
        'open': 9.233,
        'high': 9.241,
        'low': 9.166,
        'close': 9.209,
        'volume': 343580.24,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740060000000,
        'open': 9.21,
        'high': 9.337,
        'low': 9.128,
        'close': 9.136,
        'volume': 487617.07,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740063600000,
        'open': 9.137,
        'high': 9.156,
        'low': 8.986,
        'close': 9.005,
        'volume': 321980.29,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740067200000,
        'open': 9.006,
        'high': 9.273,
        'low': 8.966,
        'close': 9.22,
        'volume': 417045.05,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740070800000,
        'open': 9.22,
        'high': 9.47,
        'low': 9.188,
        'close': 9.386,
        'volume': 311690.71,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740074400000,
        'open': 9.385,
        'high': 9.481,
        'low': 9.309,
        'close': 9.324,
        'volume': 182899.36,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740078000000,
        'open': 9.324,
        'high': 9.409,
        'low': 9.304,
        'close': 9.327,
        'volume': 125893.03,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740081600000,
        'open': 9.328,
        'high': 9.383,
        'low': 9.286,
        'close': 9.308,
        'volume': 198864.26,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740085200000,
        'open': 9.308,
        'high': 9.359,
        'low': 9.225,
        'close': 9.254,
        'volume': 161667.96,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740088800000,
        'open': 9.256,
        'high': 9.399,
        'low': 9.225,
        'close': 9.326,
        'volume': 229266.03,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740092400000,
        'open': 9.326,
        'high': 9.37,
        'low': 9.324,
        'close': 9.341,
        'volume': 92457.88,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740096000000,
        'open': 9.341,
        'high': 9.366,
        'low': 9.273,
        'close': 9.292,
        'volume': 107650.67,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740099600000,
        'open': 9.292,
        'high': 9.357,
        'low': 9.227,
        'close': 9.312,
        'volume': 106782.36,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740103200000,
        'open': 9.313,
        'high': 9.337,
        'low': 9.24,
        'close': 9.251,
        'volume': 107512.09,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740106800000,
        'open': 9.252,
        'high': 9.346,
        'low': 9.244,
        'close': 9.287,
        'volume': 131161.48,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740110400000,
        'open': 9.287,
        'high': 9.385,
        'low': 9.283,
        'close': 9.366,
        'volume': 105270.97,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740114000000,
        'open': 9.366,
        'high': 9.382,
        'low': 9.296,
        'close': 9.303,
        'volume': 134735.54,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740117600000,
        'open': 9.303,
        'high': 9.321,
        'low': 9.256,
        'close': 9.274,
        'volume': 110451.38,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740121200000,
        'open': 9.274,
        'high': 9.342,
        'low': 9.255,
        'close': 9.263,
        'volume': 99162.03,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740124800000,
        'open': 9.263,
        'high': 9.368,
        'low': 9.231,
        'close': 9.306,
        'volume': 223654.69,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740128400000,
        'open': 9.308,
        'high': 9.534,
        'low': 9.297,
        'close': 9.373,
        'volume': 400268.68,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740132000000,
        'open': 9.375,
        'high': 9.471,
        'low': 9.369,
        'close': 9.454,
        'volume': 191739.31,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740135600000,
        'open': 9.455,
        'high': 9.51,
        'low': 9.4,
        'close': 9.412,
        'volume': 171367.02,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740139200000,
        'open': 9.411,
        'high': 9.493,
        'low': 9.382,
        'close': 9.486,
        'volume': 190331.29,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740142800000,
        'open': 9.486,
        'high': 9.643,
        'low': 9.474,
        'close': 9.618,
        'volume': 277789.1,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740146400000,
        'open': 9.617,
        'high': 9.628,
        'low': 9.388,
        'close': 9.47,
        'volume': 360647.96,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740150000000,
        'open': 9.47,
        'high': 9.546,
        'low': 9.028,
        'close': 9.178,
        'volume': 690998.96,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740153600000,
        'open': 9.178,
        'high': 9.391,
        'low': 9.106,
        'close': 9.213,
        'volume': 384767.91,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740157200000,
        'open': 9.214,
        'high': 9.271,
        'low': 8.9,
        'close': 8.934,
        'volume': 409267.78,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740160800000,
        'open': 8.934,
        'high': 8.953,
        'low': 8.828,
        'close': 8.851,
        'volume': 412098.93,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740164400000,
        'open': 8.851,
        'high': 8.883,
        'low': 8.586,
        'close': 8.638,
        'volume': 489925.96,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740168000000,
        'open': 8.639,
        'high': 8.833,
        'low': 8.626,
        'close': 8.711,
        'volume': 384172.28,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740171600000,
        'open': 8.711,
        'high': 8.747,
        'low': 8.621,
        'close': 8.667,
        'volume': 115709.76,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740175200000,
        'open': 8.668,
        'high': 8.754,
        'low': 8.632,
        'close': 8.714,
        'volume': 117388.1,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740178800000,
        'open': 8.714,
        'high': 8.792,
        'low': 8.67,
        'close': 8.743,
        'volume': 119603.43,
        'isLastBar': false,
        'isBarClosed': true,
    },
    {
        'time': 1740182400000,
        'open': 8.742,
        'high': 8.818,
        'low': 8.695,
        'close': 8.807,
        'volume': 52223.73,
        'isLastBar': true,
        'isBarClosed': false,
    },
];